import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'rwidget-cards-actions',
    templateUrl: './cards-actions.component.html',
    styleUrls: ['./cards-actions.component.scss'],
})
export class CardsActionsComponent {
    constructor(private router: Router, private route: ActivatedRoute) {}

    navigateToAddNewCard() {
        this.router.navigate([`add`], { relativeTo: this.route.parent });
    }
}
